import type { PostUserPermissionsPayload } from "@/core/types/(api)/permissions";
import type { UUID } from "@/core/types";

import { usePermissionsMutation } from "./usePermissionsMutation";

type UseUpdateCosignPermissionProps = {
  providerName: string;
  userId: UUID;
};

export function useUpdateCosignPermission({
  providerName,
  userId,
}: UseUpdateCosignPermissionProps) {
  return usePermissionsMutation<Extract<PostUserPermissionsPayload, { co_sign: unknown }>>({
    // Turning co-sign on is deferred to onSettled: the payload lacks display-only
    // metadata (assigned_supervisor_name, state_updated_by_name, etc.) needed to construct a
    // valid optimistic cache entry. Turning off is self-contained.
    optimisticStateResolver: (old, { co_sign }) =>
      co_sign.is_required ? undefined : { ...old, co_sign: { is_required: false } },
    userId,
    userName: providerName,
  });
}
